import { useEffect } from 'react';

export default function useScrollFix() {
  useEffect(() => {
    const bodyElement = document.body;

    bodyElement.style.cssText =
      'position: fixed; top: 0; left: 0; overflow: hidden; width: 100%';

    return () => {
      bodyElement.style.cssText = '';
    };
  }, []);
}
